import { render, staticRenderFns } from "./CurrencyCheckbox.vue?vue&type=template&id=619b6b3f&scoped=true"
import script from "./CurrencyCheckbox.vue?vue&type=script&lang=js"
export * from "./CurrencyCheckbox.vue?vue&type=script&lang=js"
import style0 from "./CurrencyCheckbox.vue?vue&type=style&index=0&id=619b6b3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "619b6b3f",
  null
  
)

export default component.exports